import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { CloseButton } from "../components/buttons/close-button";

interface PropertyPalHeaderProps {
  onClose: () => void;
}

const componentContainer =
  "flex p-4 w-full items-center justify-between gap-2.5 self-stretch bg-north-sea rounded-t-lg border-solid border-b border-b-foggy-firth";
const nameContainer = "flex flex-1";
const nameStyles = "text-neutral-white font-semibold text-body-l leading-none md:leading-none";

export const PropertyPalHeader: React.FC<PropertyPalHeaderProps> = ({ onClose }) => {
  return (
    <div className={componentContainer}>
      <div className={nameContainer}>
        <div className={nameStyles}>Edi - Your Property Pal</div>
      </div>
      <CloseButton onClick={onClose} aria-label="Close chatbot" variant="onDarkNeutral" size="lg" />
    </div>
  );
};
